import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width: 700,
      marginTop: 20,
      marginBottom: 10
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1
    },
    iconButton: {
      padding: 10
    },
    switch: {
      marginLeft: 8,
      marginBottom: 30
    },
    searchErrorMsg: {
      marginLeft: 8
    },
    table: {
      marginTop: 10
    },
    cardHeight: {
      height: '100%'
    },
    parentFlexRight: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    parentFlexColumn: {
      display: 'flex',
      flexDirection: 'column'
      // justifyContent: 'flex-end'
    },
    cardAnnouncement: {
      display: 'flex',
      flexDirection: 'row'
    },
    actionAnnouncement: {
      // marginRight: theme.spacing(2)
    },
    titleContainer: { marginLeft: theme.spacing(1) },
    iconArrowDropDown: {
      color: 'red',
      width: 40,
      height: 40
    },
    iconArrowDropUp: {
      color: 'green',
      width: 40,
      height: 40
    },
    iconArrowNeutral: {
      color: 'grey',
      width: 40,
      height: 40
    },
    kpiTextAlignRight: {
      height: '100%'
      // textAlign: 'right',
      // paddingRight: theme.spacing(2)
    },
    dividerVertical: {},
    dividerHorizontal: {
      height: '1px',
      width: '100%'
    }
  })
